import { ICustomTheme } from '../theme';

const theme: ICustomTheme = {};

export default theme;
